<template>
  <div id="app" ondragstart="return false">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
};
console.log('11')
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
</style>
